import React, { createContext, useContext, useState, ReactNode } from "react";
import { SignUpRequestWithKit } from '@viome/viome-base/src/usecase/Register/Register.model'

// Define the context type
interface SignUpContextType {
  signUpData: SignUpRequestWithKit;
  updateSignUpData: (data: (prevData: SignUpRequestWithKit) => SignUpRequestWithKit) => void;
}

// Create the context
const SignUpContext = createContext<SignUpContextType | undefined>(undefined);

// Provide the context
export const SignUpProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [signUpData, setSignUpData] = useState<SignUpRequestWithKit>({
    user: {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      phone: "",
      countryPhoneCode: "",
      smsConsent: false,
    },
    address: {
      addressID: "",
      userID: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      company: "",
      defaultAddress: false,
      kitId: "",
      isShippable: false,
    },
    dateOfBirth: "",
    gender: "",
    kitId: "",
    consentRecords: [],
  });

  const updateSignUpData = (data: (prevData: SignUpRequestWithKit) => SignUpRequestWithKit) => {
    setSignUpData(data(signUpData));
  };

  return (
    <SignUpContext.Provider value={{ signUpData, updateSignUpData }}>
      {children}
    </SignUpContext.Provider>
  );
};

// Hook to use the context
export const useSignUpContext = () => {
  const context = useContext(SignUpContext);
  if (!context) {
    throw new Error("useSignUpContext must be used within a SignUpProvider");
  }
  return context;
};
